module.exports = __webpack_public_path__ + "static/media/Renewals_infographic-1.bbf9fdaa.png";